define [], () ->
  ($rootScope, $state) ->
    restrict: "E"
    template: require("./signatureText.jade")
    scope: { field: "=", mode: "=", stage: "="}
    link: (scope, element, attrs) ->
      require('./signatureText.scss')

      scope.switch_to_draw = () ->
        $rootScope.$broadcast('switch-draw', {
          name: scope.field.name
        })

                    



// WEBPACK FOOTER //
// ./directives/freeforms/signatureText/signatureText.coffee